module.exports = __webpack_public_path__ + "static/media/screenshot-reliable.6489a04d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Home/screenshot-reliable.jpg
// module id = 647
// module chunks = 0